/* src/components/ui/AndroidA2HSModal.js */
import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faTimes } from '@fortawesome/free-solid-svg-icons';

const AndroidA2HSModal = ({ isOpen, onClose, onInstall }) => {
  if (!isOpen) return null;

  const handleInstall = () => {
      onInstall(); // Trigger the install prompt logic from parent
      // onClose(); // Optionally close immediately, or let parent handle after prompt result
  };

  const handleClose = () => {
      onClose(); // Trigger the dismiss logic from parent
  };


  return (
    <div className="fixed z-[90] inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <div className="flex items-center sm:items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        {/* Background overlay */}
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true" onClick={handleClose}></div>

        {/* Mobile bottom sheet style (or centered modal on larger screens) */}
        <div className="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center">
           <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full w-full">
             {/* Close Button */}
             <button
                 onClick={handleClose}
                 className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 focus:outline-none z-10"
                 aria-label="Close"
             >
                 <FontAwesomeIcon icon={faTimes} className="h-5 w-5" />
             </button>

             <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                 <div className="text-center">
                     <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-indigo-100 mb-4">
                          <FontAwesomeIcon icon={faDownload} className="h-6 w-6 text-indigo-600" aria-hidden="true" />
                      </div>
                     <h3 className="text-lg leading-6 font-medium text-gray-900 mb-2" id="modal-title">
                         Install App?
                     </h3>
                     <div className="mt-2 text-sm text-gray-600 space-y-3">
                         <p>
                             Add Dual N-Back to your Home Screen for quick access and an app-like experience.
                         </p>
                     </div>
                 </div>
             </div>
             <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse gap-2">
                  <button
                     type="button"
                     className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:ml-3 sm:w-auto sm:text-sm"
                     onClick={handleInstall}
                 >
                     Install
                 </button>
                 <button
                     type="button"
                     className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
                     onClick={handleClose}
                 >
                     Later
                 </button>
             </div>
           </div>
        </div>
      </div>
    </div>
  );
};

AndroidA2HSModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired, // Function to call when user dismisses
  onInstall: PropTypes.func.isRequired, // Function to call when user clicks install
};

export default AndroidA2HSModal;